import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig } from '@intelliarts/ia-react-template';

import authConfig, { HR_MENU_GROUP } from '../../../config/authConfig';
import { ONBOARDING_PAGE_LOCALE_PATH } from '../../Employee/locales';

export const OnboardingRoutes = {
  default: 'onboarding',
};

export const OnboardingPageConfig: ReactPageConfig = {
  name: `${ONBOARDING_PAGE_LOCALE_PATH}.pageConfig.name`,
  path: OnboardingRoutes.default,
  allowedRoles: [authConfig.roles.ADMIN],
  component: lazy(() => import('../components/OnboardingPage')),
  storeDependencies: [],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/PersonAdd')),
    label: `${ONBOARDING_PAGE_LOCALE_PATH}.pageConfig.label`,
    group: HR_MENU_GROUP,
    isCollapsibleGroup: true,
  }),
};
